import React from 'react'
import SelectedMealsPanel from '../../../components/SelectedMeals'

const SelectedMeals = props => {
  const {
    isOpen,
    onClose,
    products,
    addProduct,
    removeProduct,
    clearOrder,
    subtotal,
    mealCount,
    orderSummaryLoading,
    onCheckout
  } = props

  return (
    <SelectedMealsPanel
      isOpen={isOpen}
      onClose={onClose}
      clearOrder={clearOrder}
      products={products}
      addProduct={addProduct}
      removeProduct={removeProduct}
      subtotal={subtotal}
      mealCount={mealCount}
      onCheckout={onCheckout}
      orderSummaryLoading={orderSummaryLoading}
    />
  )
}

export default SelectedMeals



// WEBPACK FOOTER //
// ./src/modules/Menu/SelectedMeals/SelectedMeals.jsx